export const StepTypes = {
    AGREEMENT: 'AGREEMENT',
    PRE_REGISTER: 'PRE_REGISTER',
    REGISTER: 'REGISTER',
    COMPANY: 'COMPANY',
    INDIVIDUAL: 'INDIVIDUAL',
    REGISTER_ONE: 'REGISTER_ONE',
    REGISTER_TWO: 'REGISTER_TWO'
};
